/**
 * CMS 数据转换辅助函数
 *
 * 后端 CmsContent 模型：
 *   { id, type, title, imageUrl, markdown, publishTime, sortOrder, extraData }
 *   title 可由后端从 markdown 第一个 # 自动提取
 *   图片/文件链接直接写在 markdown 中：![alt](url) / [name](url)
 */

function extractTitle (markdown) {
  if (!markdown) return ''
  const match = markdown.match(/^#{1,6}\s+(.+?)(?:\s*\{[^}]*\})?\s*$/m)
  if (match) return match[1].trim()
  const firstLine = markdown.trim().split('\n')[0]
  return firstLine ? firstLine.replace(/^#+\s*/, '').trim() : ''
}

export function fromCmsContent (item) {
  if (!item) return item

  let extra = {}
  try {
    if (item.extraData) {
      extra = typeof item.extraData === 'string' ? JSON.parse(item.extraData) : item.extraData
    }
  } catch (e) { /* ignore */ }
  if (!extra || typeof extra !== 'object') extra = {}

  const markdown = item.markdown || ''
  const derivedTitle = extractTitle(markdown)

  const result = {
    id: item.id,
    type: item.type,
    title: item.title || derivedTitle || extra.title || '',
    markdown: markdown,
    content: markdown,
    description: markdown,
    imageUrl: item.imageUrl || extra.imageUrl || '',
    publishTime: item.publishTime,
    sortOrder: item.sortOrder,
    createdAt: item.createdAt,
    updatedAt: item.updatedAt,
    // 学术成果字段（extraData）
    articleTitle: extra.articleTitle || derivedTitle,
    authorFullNames: extra.authorFullNames || '',
    affiliations: extra.affiliations || '',
    fundingName: extra.fundingName || '',
    publisher: extra.publisher || '',
    journalAbbreviation: extra.journalAbbreviation || '',
    publicationDate: extra.publicationDate || '',
    publicationYear: extra.publicationYear || null,
    articleUrl: extra.articleUrl || '',
    logoUrl: extra.logoUrl || ''
  }

  for (const key of Object.keys(extra)) {
    if (!(key in result)) {
      result[key] = extra[key]
    }
  }

  return result
}

export function toCmsContent (data, type) {
  if (!data) return data

  const markdown = data.markdown || data.content || data.description || ''

  const topLevelFields = [
    'id', 'type', 'title', 'imageUrl', 'markdown', 'publishTime', 'sortOrder',
    'mediaList', 'createdAt', 'updatedAt',
    'content', 'description', 'images', 'files', 'logoUrl'
  ]
  const extraData = {}

  for (const key of Object.keys(data)) {
    if (!topLevelFields.includes(key) && data[key] !== undefined && data[key] !== '') {
      extraData[key] = data[key]
    }
  }

  if (data.logoUrl !== undefined) extraData.logoUrl = data.logoUrl
  if (data.articleTitle !== undefined) extraData.articleTitle = data.articleTitle
  if (data.authorFullNames !== undefined) extraData.authorFullNames = data.authorFullNames
  if (data.affiliations !== undefined) extraData.affiliations = data.affiliations
  if (data.fundingName !== undefined) extraData.fundingName = data.fundingName
  if (data.publisher !== undefined) extraData.publisher = data.publisher
  if (data.journalAbbreviation !== undefined) extraData.journalAbbreviation = data.journalAbbreviation
  if (data.publicationDate !== undefined) extraData.publicationDate = data.publicationDate
  if (data.publicationYear !== undefined) extraData.publicationYear = data.publicationYear

  const result = {
    type: data.type || type || '',
    markdown: markdown,
    publishTime: data.publishTime || null,
    sortOrder: data.sortOrder !== undefined ? data.sortOrder : 0
  }

  if (data.id) result.id = data.id
  if (data.title !== undefined) result.title = data.title
  if (data.imageUrl !== undefined) result.imageUrl = data.imageUrl

  if (Object.keys(extraData).length > 0) {
    result.extraData = JSON.stringify(extraData)
  }

  return result
}

export function mapPageResult (res) {
  if (res && res.code === 1 && res.data && Array.isArray(res.data.rows)) {
    res.data.rows = res.data.rows.map(fromCmsContent)
  }
  // 后端返回 totalPages 字段，此处直接透传
  return res
}

// 获取后端返回的总页数（如无则用 total 计算）
export function getTotalPages (data) {
  if (!data) return 0
  if (data.totalPages != null) return data.totalPages
  if (data.total != null && data.rows) {
    const pageSize = data.rows.length || 10
    return Math.ceil(data.total / pageSize)
  }
  return 0
}

export function mapSingleResult (res) {
  if (res && res.code === 1 && res.data) {
    res.data = fromCmsContent(res.data)
  }
  return res
}
